/**
 * Canva page palettes — Photos 1–6 (Jun 2026).
 * `NAV_TITLE_FONT` in HeaderBar stays Atkinson Hyperlegible for all schemes.
 */

export const PAGE_SCHEMES = {
  venue: {
    light: {
      headerBackground: '#D9ED92',
      headerTitle: '#FF7F50',
      headerWelcome: '#4361EE',
      pageBackground: '#3D7FE6',
      footerBackground: '#3D7FE6',
      specSheetBar: '#00A575',
    },
    dark: {
      headerBackground: '#000000',
      headerTitle: '#FFFFFF',
      headerWelcome: '#0bb5df',
      pageBackground: '#3D7FE6',
      footerBackground: '#3D7FE6',
      specSheetBar: '#00A575',
    },
  },
  gearSwap: {
    light: {
      headerBackground: '#D4F538',
      headerTitle: '#4361EE',
      headerWelcome: '#FF7A00',
      pageBackground: '#D4F538',
      footerBackground: '#FF7A00',
      accent: '#FF7A00',
    },
    dark: {
      headerBackground: '#FAFAFA',
      headerTitle: '#111111',
      headerWelcome: '#03bb8d',
      pageBackground: '#FAFAFA',
      footerBackground: '#D4F538',
      accent: '#03bb8d',
    },
  },
  calendar: {
    light: {
      headerBackground: '#FFFFFF',
      headerTitle: '#03bb8d',
      headerWelcome: '#03bb8d',
      pageBackground: '#FFFFFF',
      footerBackground: '#E9E9E9',
      gridAccent: '#03bb8d',
      gridBorder: '#9333EA',
    },
    dark: {
      headerBackground: '#000000',
      headerTitle: '#D4F538',
      headerWelcome: '#D4F538',
      pageBackground: '#4361EE',
      footerBackground: '#FFFFFF',
      gridAccent: '#D4F538',
    },
  },
};

const ROUTE_SCHEME = {
  Venue: 'venue',
  GearSwapList: 'gearSwap',
  GearSwapPostCreate: 'gearSwap',
  MyCalendar: 'calendar',
  CalendarDayDetails: 'calendar',
};

export function resolvePageScheme(routeName, override) {
  if (override) return override;
  return ROUTE_SCHEME[routeName] || null;
}

export function getPagePalette(scheme, isDarkMode) {
  if (!scheme || !PAGE_SCHEMES[scheme]) return null;
  return PAGE_SCHEMES[scheme][isDarkMode ? 'dark' : 'light'];
}

/** Returns palette only when the updated color scheme feature flag is enabled. */
export function getPagePaletteIfEnabled(scheme, isDarkMode, enabled) {
  if (!enabled) return null;
  return getPagePalette(scheme, isDarkMode);
}
